var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { useTranslation } from "react-i18next";
import { AppBar, Box, Container, CssBaseline, Toolbar, } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { locales } from "frontend/src/domain/localization/i18n";
import { LanguageSwitcher } from "frontend/src/domain/localization";
var useStyles = makeStyles(function (theme) { return ({
    toolbar: __assign(__assign({}, theme.mixins.toolbar), { flexDirection: "row-reverse" }),
}); });
export var GuestUserLayout = function (_a) {
    var children = _a.children;
    var classes = useStyles();
    var ready = useTranslation(locales.namespaces.guest).ready;
    if (!ready)
        return null;
    return (React.createElement(Box, null,
        React.createElement(CssBaseline, null),
        React.createElement(AppBar, { position: "static" },
            React.createElement(Toolbar, { className: classes.toolbar },
                React.createElement(LanguageSwitcher, { showWarning: true }))),
        React.createElement(Container, { component: "main", maxWidth: "xs" },
            React.createElement(Box, { mt: 3 }, children))));
};
